import FieldsRadio from './Fields/FieldsRadio'
import FieldsNumber from './Fields/FieldsNumber'
import FieldsText from './Fields/FieldsText'
import FieldsDate from './Fields/FieldsDate'

export default function FormatFields({ 
  classes,
  field,
  handleInput,
  formSelected,
  fields
 }) {
  if (field.type === 'radio') {
    return (
      <FieldsRadio 
        classes={classes}
        handleInput={handleInput}
        field={field}
        formSelected={formSelected}
      />
    )
  }
  else if (field.type === 'number') {
    return (
      <FieldsNumber 
        classes={classes}
        field={field}
        handleInput={handleInput}
        formSelected={formSelected}
      />
    )
  }
  else if (field.type === 'text') {
    return (
      <FieldsText 
        classes={classes}
        field={field}
        handleInput={handleInput}
        formSelected={formSelected}
      />
    )
  }
  else if (field.type === 'date') {
    return (
      <FieldsDate 
        classes={classes}
        field={field}
        handleInput={handleInput}
        formSelected={formSelected}
      />
    )
  }

  return fields[field.type]
}